(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["october-drop"] && !Shopify.designMode) return;
  try {
    
function dropState(launch, now, confirmedLive) {
  if (!Number.isFinite(launch) || !Number.isFinite(now)) return 'waiting';
  if (now < launch) return 'upcoming';
  return confirmedLive ? 'live' : 'waiting';
}

function dropParts(launch, now) {
  const total = Math.max(0, Math.ceil((launch - now) / 1000));
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor(total % 86400 / 3600),
    minutes: Math.floor(total % 3600 / 60),
    seconds: total % 60
  };
}

class OctoberDrop extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.launch = Date.parse(this.dataset.launch);
    this.serverTime = Number(this.dataset.serverNow) * 1000;
    this.syncedAt = performance.now();
    this.confirmedLive = this.dataset.state === 'live';
    this.lastChecked = -Infinity;
    this.syncing = false;
    this.onResume = () => {
      if (document.visibilityState === 'visible') { this.refresh(); this.tick(); }
    };
    document.addEventListener('visibilitychange', this.onResume);
    window.addEventListener('pageshow', this.onResume);
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
    this.refresh();
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    this.abort?.abort();
    document.removeEventListener('visibilitychange', this.onResume);
    window.removeEventListener('pageshow', this.onResume);
    this.started = false;
  }

  now() { return this.serverTime + performance.now() - this.syncedAt; }

  tick(checkAvailability = true) {
    const now = this.now();
    const state = dropState(this.launch, now, this.confirmedLive);
    const changed = this.dataset.state !== state;
    this.dataset.state = state;
    this.querySelector('[data-drop-heading]').textContent = state === 'live' ? this.dataset.headingLive : this.dataset.headingUpcoming;
    this.querySelector('[data-drop-timer]').hidden = state !== 'upcoming';
    this.querySelector('[data-drop-waiting]').hidden = state !== 'waiting';
    this.querySelector('[data-drop-before]').hidden = state === 'live';
    this.querySelector('[data-drop-shop]').hidden = state !== 'live';
    this.querySelectorAll('[data-product-shop]').forEach(link => { link.hidden = state !== 'live'; });
    if (state === 'upcoming') {
      const parts = dropParts(this.launch, now);
      Object.entries(parts).forEach(([part, value]) => { this.querySelector(`[data-part="${part}"]`).textContent = String(value).padStart(2, '0'); });
    }
    const interval = state === 'waiting' || this.launch - now < 60000 ? 15000 : 60000;
    if (checkAvailability && !this.syncing && (changed || performance.now() - this.lastChecked >= interval)) this.refresh();
  }

  async refresh() {
    if (this.syncing || !this.isConnected) return;
    this.syncing = true;
    this.lastChecked = performance.now();
    this.abort = new AbortController();
    const timeout = setTimeout(() => this.abort.abort(), 10000);
    try {
      const url = new URL(this.dataset.root, location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('_drop_check', String(Date.now()));
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin', signal: this.abort.signal });
      if (!response.ok) throw new Error('Availability check failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('october-drop');
      if (!fresh || fresh.dataset.launch !== this.dataset.launch || fresh.dataset.sectionId !== this.dataset.sectionId) throw new Error('Invalid release response');
      const serverTime = Number(fresh.dataset.serverNow) * 1000;
      if (!Number.isFinite(serverTime) || serverTime <= 0) throw new Error('Invalid release clock');
      this.serverTime = serverTime;
      this.syncedAt = performance.now();
      this.confirmedLive = fresh.dataset.state === 'live' && fresh.dataset.ready === 'true' && serverTime >= this.launch;
    } catch {
      if (this.now() >= this.launch) this.confirmedLive = false;
    } finally {
      clearTimeout(timeout);
      this.syncing = false;
      this.tick(false);
    }
  }
}

if (!customElements.get('october-drop')) customElements.define('october-drop', OctoberDrop);


  } catch(e) { console.error(e); }
})();
})();
